import { makeStyles } from 'tss-react/mui';
import { StepContainer, StepContent, StepDescription, StepHeading, StepNavigator } from '../../components';
import { Button } from '@uplift/ui-v2';
import { useIsMobile } from '@uplift/hooks';
import { useStates } from '@uplift/queries';

export type NotAvailableProps = {
  onBack: () => void;
  stateId: string;
};

export const NotAvailable: React.VFC<NotAvailableProps> = props => {
  const isMobile = useIsMobile('sm');
  const { classes } = useNotAvailableStyles();
  const { states } = useStates();

  const state = states.find(x => x.id === props.stateId);

  return (
    <StepContainer>
      <StepContent className={classes.content}>
        <StepHeading>Sorry, we're not in your state yet</StepHeading>
        <StepDescription>We'll be in touch when we're available in {state?.fullName}</StepDescription>
        <div>
          <Button
            color="secondary"
            variant="contained"
            className={classes.button}
            fullWidth={isMobile}
            component="a"
            href="https://joinuplift.co"
          >
            Go to homepage
          </Button>
        </div>
      </StepContent>
      <StepNavigator onBack={props.onBack} desktopOnly />
    </StepContainer>
  );
};

const useNotAvailableStyles = makeStyles({ name: 'NotAvailable' })(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  button: {
    marginTop: theme.spacing(3)
  }
}));
